"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminForm = void 0;
const mithril_1 = __importDefault(require("mithril"));
const admin_1 = require("../../../model/admin");
const form_for_1 = require("../../../widgets/form_for");
const modal_1 = require("../../../widgets/modal");
const right_panel_1 = require("../../../widgets/right_panel");
const admin_table_1 = require("./admin_table");
function renderForm(form) {
    return (0, mithril_1.default)("div", form.errorBlock(), (0, form_for_1.fieldset)("Information d'identité", {}, form.field("E-mail", "email", "email"), (0, form_for_1.columns)(form.field("Prénom", "first_name", "text"), form.field("Nom", "last_name", "text")), form.selectField("Role", "role", [["worker", "Employé"], ["admin", "Administrateur"]])));
}
exports.AdminForm = {
    admin: {},
    active: false,
    show(admin) {
        this.admin = admin || {};
        if (admin && admin.id !== undefined) {
            admin_1.AdminProvider.show(admin.id).then((admin) => { this.admin = admin; });
        }
        this.active = true;
    },
    view(_vnode) {
        if (!exports.AdminForm.active) {
            return undefined;
        }
        let form = (0, form_for_1.formFor)(this.admin, admin_1.AdminProvider, function (form) {
            return (0, modal_1.modalCard)({
                title: `Nouvel admin`,
                content: renderForm(form),
                foot: (0, mithril_1.default)("div", { class: "is-pulled-right" }, form.submit("Envoyer", {
                    onsubmit: (obj) => {
                        exports.AdminForm.active = false;
                        admin_table_1.AdminTable.fetch();
                        right_panel_1.RightPanel.open("Admins", obj.id, "show");
                    }
                }), (0, mithril_1.default)("button", { class: "button", onclick: (e) => {
                        e.preventDefault();
                        exports.AdminForm.active = false;
                    } }, "Annuler")),
                key: "AdminForm",
                id: "admin-form",
                isActive: exports.AdminForm.active,
                onClose: () => { exports.AdminForm.active = false; }
            });
        });
        return form;
    }
};
